$(function () {
  $('.js-home-mv-slider').slick({
    infinite: true,
    centerMode: true,
    centerPadding: '2px',
    slidesToShow: 3,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 1500,
    speed: 2000,
    responsive: [{
      breakpoint: 768,
      centerMode: false,
      centerPadding: '0px',
      settings: {
        slidesToShow: 1,
      }
    }]
  });

  $('.js-home-works-slider').slick({
    slidesToShow: 3,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 1000,
    speed: 1000,
    nextArrow: $('.homeWorks__slideBtnList__item .is_next'),
    prevArrow: $('.homeWorks__slideBtnList__item .is_prev'),
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      }
    }]
	});

  $('.js-home-point-slider').slick({
    slidesToShow: 2,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 1000,
    speed: 1000,
    variableWidth: false,
    nextArrow: $('.homePoint__slideBtnList__item .is_next'),
    prevArrow: $('.homePoint__slideBtnList__item .is_prev'),
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      }
    }]
  });

  $('.homeFixedBanner__box, .homeFixedBanner__hoverBox').on('mouseenter', function () {
    $('.homeFixedBanner__hoverBox').addClass('is_open');
  }).on('mouseleave', function(){
    $('.homeFixedBanner__hoverBox').removeClass('is_open');
  });
});
